module.exports = __webpack_public_path__ + "img/Photo34.ae1f8d7a.jpg";